<template>
  <nx-dialog
    :visible.sync="show"
    title="基础数据导入"
    width="600px"
    :before-close="beforeClose"
    @onConfirm="onConfirm"
  >
    <nx-form
      ref="submitForm"
      :source="submitForm"
      :config="submitConfig"
    >
      <div slot="file">
        <nx-upload-backend
          v-if="!submitForm.file"
          class=""
          :reg="/.(xls|xlsx)$/"
          @onSuccess="uploadSuccess"
        >
          <el-button type="primary">上传文件</el-button>
        </nx-upload-backend>
        <div v-if="submitForm.file && submitForm.file.name">
          {{ submitForm.file.name }}
          <i
            class="el-icon-delete nx-text-danger"
            style="font-size:16px;"
            @click.stop="handleRemove()"
          ></i>
        </div>

        <el-button type="primary" style="margin-top:20px;" plain @click="handDownload(submitForm.dataType)">
          {{ submitForm.dataType == 0 ? '下载CAN矩阵模板' : '下载故障字典模板' }}
        </el-button>
      </div>
    </nx-form>

    <nx-result
      :visible.sync="failedDialogConfig.status"
      :table-data="failedDialogConfig.tableData"
      :info="failedDialogConfig.info"
      :table-column="[{ label: '行号', prop: 'rowNum' }, { label: '失败原因', prop: 'errorMsg' }]"
    ></nx-result>
  </nx-dialog>
</template>
<script>
import { dataTypes, stageTypes } from '../../config.js';
import { dataBaseAdd, dataBaseCanDownload, dataBaseFaultDownload } from '@/api/dataService/base.js';

export default {
  props: {
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      dataTypes,
      show: false,
      submitForm: {
        dataType: 0, // 基础数据类型
        codes: '', // 品牌车系车型
        stage: [], // 适用阶段
        // stage: '', // 适用阶段
        version: '', // 版本
        file: ''// 上传文件
      },
      failedDialogConfig: {
        status: false,
        tableData: [],
        info: {
          all: 0,
          success: 0,
          failed: 0
        }
      }
    };
  },
  computed: {
    submitConfig() {
      return [
        {
          key: 'dataType',
          component: 'el-radio-group',
          span: 24,
          label: '基础数据类型:',
          labelWidth: '130px',
          data: dataTypes,
          itemProps: {
            rules: [
              { required: true, message: '请选择基础数据类型', trigger: 'blur' }
            ]
          }
        },
        {
          key: 'codes',
          component: 'NxSelectBrandTree',
          label: '品牌/车系/车型:',
          labelWidth: '130px',
          span: 24,
          itemProps: {
            rules: [
              { required: true, message: '请选择品牌/车系/车型', trigger: 'blur' }
            ]
          }
        },
        {
          key: 'stage',
          // component: 'el-radio-group',
          component: 'el-checkbox-group',
          span: 24,
          label: '适用阶段:',
          labelWidth: '130px',
          data: stageTypes,
          itemProps: {
            rules: [
              { required: true, message: '请选择适用阶段', trigger: 'blur' }
            ]
          }
        },
        {
          key: 'version',
          component: 'el-input',
          span: 24,
          label: '版本:',
          labelWidth: '130px',
          props: {
            placeholder: '请输入导入文件版本',
            maxlength: 36
          },
          itemProps: {
            rules: [
              { required: true, message: '请输入导入文件版本', trigger: 'blur' },
              { validator: (rule, value, callback) => {
                if (value.length < 3 || value.length > 36) {
                  return callback(new Error('请输入长度为3-36位的字符'));
                }
                if (this.$validate.hasSinogram(value)) {
                  return callback(new Error('不能输入汉字'));
                }
                if (this.$validate.hasSpace(value)) {
                  return callback(new Error('不能输入空格'));
                }
                callback();
              }, trigger: 'blur' }
            ]
          }
        },
        {
          key: 'file',
          component: 'slot',
          slotName: 'file',
          label: '上传文件:',
          labelWidth: '130px',
          span: 24,
          itemProps: {
            rules: [
              { required: true, message: '请选择文件', trigger: 'change' }
            ]
          }
        },
        {
          component: 'slot',
          slotName: 'download',
          span: 24
        }
      ];
    }
  },
  watch: {
    visible: {
      handler(visible) {
        this.show = visible;
      }
    },
    show: {
      handler(show) {
        this.$emit('update:visible', show);
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    async handDownload(type) {
      if (type === 0) {
        // 下载CAN矩阵模板
        await dataBaseCanDownload();
      }
      else {
        // 下载故障字典模板
        await dataBaseFaultDownload();
      }
    },
    // 文件导入成功的回调
    async uploadSuccess(file) {
      this.submitForm.file = file;
    },
    handleRemove() {
      this.submitForm.file = '';
    },
    async onConfirm() {
      const valid = await this.$refs.submitForm.validate();
      if (!valid) return;
      const [brand = '', series = '', mode = ''] = this.submitForm.codes || [];
      const params = {
        ...this.submitForm,
        brand,
        series,
        mode
      };
      delete params.codes;
      const data = await dataBaseAdd(params).catch((err) => {
        const data = err.data;
        this.failedDialogConfig = {
          status: true,
          tableData: data?.failRecords,
          info: {
            all: +data?.failCount + +data?.successCount,
            success: data?.successCount,
            failed: data?.failCount
          }
        };
        return false;
      });
      if (!data) return;
      this.$message.success('导入成功');
      this.show = false;
      this.$emit('onConfirm');
    },
    beforeClose(done) {
      this.$refs.submitForm.resetFields();
      this.failedDialogConfig.status = false;
      done();
    }
  }
};
</script>
<style scoped lang="scss">
</style>
